<template>
  <div>
    <loader-container :loading="loading" class="mb-5">
      <div class="flex flex-wrap -mx-3 mb-3">
        <figure-tile class="panel-hover">
          <div class="flex items-center justify-center rounded-full w-10 h-10 bg-blue-lighter transition scale-out">
            <span class="text-base text-blue-dark">ALL</span>
          </div>

          <span class="text-4xl font-semibold">{{ sales }}</span>

          <span class="text-base text-gray-dark">Sales</span>
        </figure-tile>

        <figure-tile class="panel-hover">
          <div class="flex items-center justify-center rounded-full w-10 h-10 bg-purple-lighter transition scale-out">
            <span class="fas fa-chart-pie text-2xl text-purple-dark"></span>
          </div>

          <span class="text-3xl font-semibold">{{ marketValue.toLocaleString('en-GB', { style: 'currency', currency:'GBP' }) }}</span>

          <span class="text-base text-gray-dark">Total Market Value</span>
        </figure-tile>

        <figure-tile class="panel-hover">
          <div class="flex items-center justify-center rounded-full w-10 h-10 bg-yellow-light transition scale-out">
            <span class="fas fa-key text-2xl text-yellow-darker"></span>
          </div>

          <span class="text-3xl font-semibold">{{ avgSold.toLocaleString('en-GB', { style: 'currency', currency:'GBP' }) }}</span>

          <div class="flex justify-between items-center border-gray-lighter">
            <div class="text-base text-gray-dark mr-4">Av. Sold Price</div>
            <value-difference :value="avgSoldValueDifference" />
          </div>
        </figure-tile>

        <figure-tile class="panel-hover">
          <div class="flex items-center justify-center rounded-full w-10 h-10 bg-green-lighter transition scale-out">
            <span class="fas fa-pound-sign text-2xl text-green-dark"></span>
          </div>

          <span class="text-3xl font-semibold">{{ avgSoldCommission.toLocaleString('en-GB', { style: 'currency', currency:'GBP' }) }}</span>

          <span class="text-base text-gray-dark">Av. Commission per property</span>
        </figure-tile>
      </div>

      <div class="flex flex-wrap mb-6">
        <div class="w-full p-6 border">
          <div class="w-full lg:w-3/4">
            <div class="h-42">
              <h2 class="text-xl font-semibold mb-3">
                Total Fee Income <span class="text-sm">(100% of Market):</span>
              </h2>

              <div class="flex items-center justify-between mb-2">
                <div class="w-1/2">
                  <div class="flex items-center justify-between mb-4">
                    <span class="text-sm md:text-base">Your Commission Fee</span>
                    <span class="text-sm text-gray-dark">{{ commissionFeePercentage }}%</span>
                  </div>

                  <range-input
                    ref="commissionSlider"
                    :min="0"
                    :step="0.10"
                    :max="5"
                    v-model="commissionFeePercentage"
                  />
                </div>

                <span class="text-xl md:text-4xl font-semibold text-blue-dark select-none">=</span>

                <span class="text-xl md:text-4xl font-semibold">{{ totalMarketCommission.toLocaleString('en-GB', { style: 'currency', currency:'GBP' }) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </loader-container>

    <region-charts @avg-sold-value-difference-changed="avgSoldValueDifferenceChanged" :charts="this.data.charts" />
  </div>
</template>

<script>
import FigureTile from '../../components/charts/FigureTile'
import ValueDifference from '../../components/charts/ValueDifference'
import RangeInput from '../../components/forms/RangeInput'
import RegionCharts from './RegionCharts'

export default {
  name: 'FiguresAndCharts',

  components: {
    FigureTile,
    RangeInput,
    RegionCharts,
    ValueDifference
  },

  mounted () {
    this.getFigures()
  },

  data () {
    return {
      loading: false,
      sales: 0,
      marketValue: 0,
      avgSold: 0,
      avgCommission: 0,
      avgSoldValueDifference: 0,
      commissionFeePercentage: 1.5
    }
  },

  props: {
    data: {
      type: Object,
      default: null
    }
  },

  computed: {
    totalMarketCommission () {
      return (this.commissionFeePercentage / 100) * this.marketValue
    },

    avgSoldCommission () {
      return (this.commissionFeePercentage / 100) * this.avgSold
    }
  },

  methods: {
    getFigures () {
      this.sales = this.data.figures.pp_count
      this.marketValue = this.data.figures.pp_sum
      this.avgSold = this.data.figures.pp_avg
    },

    /**
     * set avgSoldValueDifference when this number is changed from child component regionCharts
     */
    avgSoldValueDifferenceChanged (difference) {
      this.avgSoldValueDifference = difference
    }
  }
}
</script>

<style lang="scss" scoped>
.transition {
  transition: .3s transform
}

.panel-hover:hover .scale-out {
  transform: scale(1.5)
}

</style>
